// Delivery hours (0-24) for dropdowns
export const deliveryHours = [
  { text: "00", val: "00" },
  { text: "01", val: "01" },
  { text: "02", val: "02" },
  { text: "03", val: "03" },
  { text: "04", val: "04" },
  { text: "05", val: "05" },
  { text: "06", val: "06" },
  { text: "07", val: "07" },
  { text: "08", val: "08" },
  { text: "09", val: "09" },
  { text: "10", val: "10" },
  { text: "11", val: "11" },
  { text: "12", val: "12" },
  { text: "13", val: "13" },
  { text: "14", val: "14" },
  { text: "15", val: "15" },
  { text: "16", val: "16" },
  { text: "17", val: "17" },
  { text: "18", val: "18" },
  { text: "19", val: "19" },
  { text: "20", val: "20" },
  { text: "21", val: "21" },
  { text: "22", val: "22" },
  { text: "23", val: "23" },
  { text: "24", val: "24" },
];

// Delivery minutes for dropdowns
export const deliveryMinutes = [
  { text: "00", val: "00" },
  { text: "15", val: "15" },
  { text: "30", val: "30" },
  { text: "45", val: "45" },
];

// Default time settings structure for days
export const defaultDayTimeSettings = {
  time: {
    time_hour: "",
    time_minut: "",
  },
  day_before_limit: "",
  day_after_limit: "",
};

// Default shift settings structure
export const defaultShiftSettings = {
  delivery_from_hour: "",
  delivery_from_min: "",
  delivery_to_hour: "",
  delivery_to_min: "",
};

// Default weekly time settings
export const defaultWeeklyTimeSettings = {
  monday: { ...defaultDayTimeSettings },
  tuesday: { ...defaultDayTimeSettings },
  wednesday: { ...defaultDayTimeSettings },
  thursday: { ...defaultDayTimeSettings },
  friday: { ...defaultDayTimeSettings },
  saturday: { ...defaultDayTimeSettings },
  sunday: { ...defaultDayTimeSettings },
  day: {
    monday: "",
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
    saturday: "",
    sunday: "",
  },
};

// Function to create a fresh copy of weekly time settings
export const createWeeklyTimeSettings = () => ({
  monday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  tuesday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  wednesday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  thursday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  friday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  saturday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  sunday: {
    time: {
      time_hour: "",
      time_minut: "",
    },
    day_before_limit: "",
    day_after_limit: "",
  },
  day: {
    monday: "",
    tuesday: "",
    wednesday: "",
    thursday: "",
    friday: "",
    saturday: "",
    sunday: "",
  },
});

// Function to create complete company settings structure
export const createDefaultCompanySettings = () => ({
  shift_one: {
    delivery_from_hour: "",
    delivery_from_min: "",
    delivery_to_hour: "",
    delivery_to_min: "",
  },
  shift_two: {
    delivery_from_hour: "",
    delivery_from_min: "",
    delivery_to_hour: "",
    delivery_to_min: "",
  },
  shift_three: {
    delivery_from_hour: "",
    delivery_from_min: "",
    delivery_to_hour: "",
    delivery_to_min: "",
  },
  shift_four: {
    delivery_from_hour: "",
    delivery_from_min: "",
    delivery_to_hour: "",
    delivery_to_min: "",
  },
  days: createWeeklyTimeSettings(),
  order_from_one_shift_to_another_can: true,
  global_restaurant_time_settings: false,
  current_shift_meal: false,
  confirm_delivery: false,
  order_from_one_shift_to_another: true,
  can_see_report: false,
  all_cooperation: false,
});
